import './App.css'
import React from 'react'
import Cookies from './Cookies'
import Login from './Login'
import Lists from './Lists'

// // delete me
// set_cookie('boys_sl_cookies', '')
// set_cookie('boys_sl_username', '')
// set_cookie('boys_sl_token', '')

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      cookies: getCookie('boys_sl_cookies') ?? null,
      username: getCookie('boys_sl_username') ?? null,
      token: getCookie('boys_sl_token') ?? null
    }
  }

  render = () => {
    if (!this.state.cookies) {
      return <Cookies setCookies={this.setCookies} />
    }
    else if (this.state.token === null) {
      return <Login setUsernameAndToken={this.setUsernameAndToken} />
    }
    else {
      return (
        <Lists
          username={this.state.username}
          token={this.state.token}
          bootToLogin={this.bootToLogin}
        />
      )
    }
  }

  setCookies = (cookies) => {
    this.setState({ cookies: cookies })
    if (cookies) {
      setCookie('boys_sl_cookies', 'true')
    }
    else {
      setCookie('boys_sl_cookies', '')
    }
  }

  setUsernameAndToken = (username, token) => {
    this.setState({ username: username, token: token })
    setCookie('boys_sl_username', username)
    setCookie('boys_sl_token', token)
  }

  bootToLogin = () => {
    this.setState({ username: null, token: null })
    setCookie('boys_sl_username', '')
    setCookie('boys_sl_token', '')
  }
}

export default App


// https://www.w3schools.com/js/js_cookies.asp

export function setCookie(cname, cvalue, exdays=30) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}